<template lang="pug">
#app(:class="browserClass")
  Loading
  Chat(v-show = "showChat")
  Nav(
    :logoClr="$route.meta.logoClr || 'black'",
    :menuClr="$route.meta.menuClr || 'black'",
    :langClrLg="$route.meta.langClrLg || 'black'",
    :langClrSm="$route.meta.langClrSm || 'white'",
    ref="nav"
    )
  router-view(:key="$route.fullPath")
  .texture(
    :class="{ minHeight: $route.name == 'Home' || $route.name == 'Explore' , hidden: $route.name == 'EpidemicPrevention'|| $route.name == 'About'}"
  )
  svg.filter-library(width="100%", height="100%")
    defs
      filter#dropshadowA(
        x="0",
        y="0",
        width="500%",
        height="500%",
        filterUnits="userSpaceOnUse"
      )
        feDropShadow(
          in="",
          dx="0",
          dy="0",
          stdDeviation="0",
          flood-color="white",
          flood-opacity="1"
        )
  svg.filter-library(width="100%", height="100%")
    defs
      filter#dropshadow(
        x="0",
        y="0",
        width="500%",
        height="500%",
        filterUnits="userSpaceOnUse"
      )
        feOffset(result="offOut", in="SourceGraphic", dx="0", dy="0")
        feGaussianBlur(
          result="blurOut",
          in="offOut",
          stdDeviation="0",
          edgeMode="wrap"
        )
        feBlend(in="SourceGraphic", in2="blurOut", mode="normal")
</template>

<script>
import Nav from "@/components/Nav.vue";
import Loading from "@/components/Loading.vue";
import Chat from "@/components/Chat.vue";
import $ from "jquery";
export default {
  components: {
    Nav,
    Loading,
    Chat
  },
  metaInfo: {
    title: "台北智慧城市 Smart City Taipei",
    meta: [
      {
        name: "description",
        content:
          "2020臺北願景館以線上展方式向全球同步公開亮相，邀集大眾前來構建智慧城市的藍圖，以科技防疫主題打造臺北市成為全球智慧城市中傑出的領導形象。臺北市政府資訊局及臺北智慧城市專案辦公室，參考國際標竿城市作法與府內執行進度，與局處合作提出以「智慧政府」為主體，推動「智慧建築」、「智慧交通」、「智慧教育」、「智慧健康」、「智慧安防」、「智慧環境」、與「智慧經濟」七大領域，同時設立1+7領域之智慧城市推動小組，以加速臺北市智慧城市的發展。"
      },
      {
        name: "keyword",
        content:
          "smart city taipei 智慧 物聯網 城市 論壇 台灣 博覽會 區塊鏈 台北市政府"
      },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "台北智慧城市 Smart City Taipei" },
      { property: "og:description", content: "2020臺北願景館以線上展方式向全球同步公開亮相，邀集大眾前來構建智慧城市的藍圖，以科技防疫主題打造臺北市成為全球智慧城市中傑出的領導形象。臺北市政府資訊局及臺北智慧城市專案辦公室，參考國際標竿城市作法與府內執行進度，與局處合作提出以「智慧政府」為主體，推動「智慧建築」、「智慧交通」、「智慧教育」、「智慧健康」、「智慧安防」、「智慧環境」、與「智慧經濟」七大領域，同時設立1+7領域之智慧城市推動小組，以加速臺北市智慧城市的發展。" },
      { property: "og:url", content: "http://pavilion.smartcity.taipei/" },
      { property: "og:site_name", content: "台北智慧城市 Smart City Taipei" },
      { property: "og:image", content: "https://pavilion.smartcity.taipei/index.png" },
    ]
  },
  computed: {
    browserClass() {
      return (
        "browser_" +
        (this.$store.state.browser.name.replace(/ /g, "_") || "").toLowerCase()
      );
    },
    showChat() {
      // console.log(this.$route)
      if(this.$route.name == "Home" || this.$route.path.includes('explore')){
        return true
      }else{
        return false
      }
    }
  },
  mounted() {
    console.log(this.$route)
    setTimeout(() => {
      window.onscroll = e => {
        if (window.scrollY > 50) {
          $(".icon-home").addClass("hideIcon");
        } else {
          $(".icon-home").removeClass("hideIcon");
        }
      };
    }, 1000);
  }
};
</script>

<style lang="sass">
@import "@/assets/css/mixins.scss"

html, body
  width: 100%
  height: 100%
  overflow: initial
  // overflow: scroll

#app
  width: 100%
  min-height: 100%
  overflow: hidden
  position: relative
  // max-width: 100vw
  // max-height: 100vh
  font-family: 'Noto Sans TC',Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #2c3e50

.hideIcon
  // display: none
  z-index: 0
  opacity: 0
  transition: linear 0.5s
  pointer-events: none

.texture
  width: 100%
  height: 100%
  background-image: url("/img/canvas_texture.jpg")
  background-repeat: repeat
  z-index: 1000
  position: absolute
  left: 0
  top: 0
  pointer-events: none
  mix-blend-mode: multiply
  opacity: 0.4
  &.minHeight
    min-height: $size__site_min_height
  &.hidden
    display: none

.sub_texture
  &::before
    content: ''
    width: 100%
    height: 100%
    background-image: url("/img/canvas_texture.jpg")
    background-repeat: repeat
    z-index: 1000
    position: absolute
    left: 0
    top: 0
    pointer-events: none
    mix-blend-mode: multiply
    opacity: 0.4

svg.filter-library
  position: fixed
  left: -1000px
  top: -1000px

h1,h2,h3,h4,h5,h6,p
  line-height: 1.8
  letter-spacing: 1.5

// IE and Edge stuff
 /* IE10+ CSS */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
  .home #home-selections .logo
    width: 300px
  .texture
    display: none

// Edge
@supports (-ms-accelerator:true) or (-ms-ime-align:auto)
  .home #home-selections .logo
    width: 300px
  .texture
    display: none

.browser_microsoft_edge
  svg image
    opacity: 0.5
.browser_microsoft_edge svg #f8f006d3-2fc2-4d01-9fea-be5b9f02aa79 image
  opacity: 1

/* Hide scrollbar for Chrome, Safari and Opera */
*::-webkit-scrollbar
  display: none

/* Hide scrollbar for IE, Edge and Firefox */
*
  -ms-overflow-style: none
  scrollbar-width: none
</style>
